import { FLAGS_SECTION_V2_FLAG_KEY } from '@/features/flags-dev/flags-section-v2-flag';
import { setOverride } from '@/features/flags-dev/overrides';
import { Button } from '@heidi/design-system/button';
import { TypographyCaption, TypographyP2SemiBold } from '@heidi/design-system/typography';

export function FeatureFlagsDevSectionV2() {
  return (
    <section aria-labelledby="dev-flags-section-heading" className="mt-4">
      <TypographyP2SemiBold id="dev-flags-section-heading" className="mb-1">
        Feature flags
      </TypographyP2SemiBold>
      <TypographyCaption className="mb-3 text-text-tertiary">
        Rebuild in progress — nothing here yet. Overrides set in the legacy list remain in
        effect.
      </TypographyCaption>

      <Button
        type="button"
        variant="outline"
        size="xs"
        onClick={() => setOverride('flagsmith', FLAGS_SECTION_V2_FLAG_KEY, 'off')}
      >
        Use the legacy flags list
      </Button>
    </section>
  );
}
